import React, { useState, useRef, useEffect } from "react";
import "../../Styles/Home.css";
import ProductCard from "../../Components/Cards/Card";
import "../../Styles/ProductCard.css";
import TestimonialsSection from "../Cards/TestimonialsSection";
import BlogSection from "../Cards/BlogSection";
import { useNavigate } from "react-router-dom";
import dental from "../../assests/download.jpg";
import Modal from "../Modal/Modal";
import { FaChevronDown, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import {
  FiCreditCard,
  FiHeadphones,
  FiRotateCcw,
  FiTruck,
} from "react-icons/fi";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";

import { Pagination } from "swiper/modules";
import smallbanner from "../../assests/small-bannerimg.webp";

import { Navigation, Autoplay } from "swiper/modules";
import { getViewportIsMobile } from "../../utils/browser";
import {
  CLINICAL_PLANNERS_PATH,
  isClinicalPlannersCategory,
} from "../../utils/clinicalPlanners";

function CategoryProductCarousel({
  section,
  onclickcart,
  onclickaddwishlist,
  removewishlistrequest,
  makeCartData,
  cleanNumber,
  getDiscountedPrice,
}) {
  const scrollRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);
  const products = Array.isArray(section?.products) ? section.products : [];
  const isTopSellerSection = section?.section_key === "top_seller";

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    const updateScrollButtons = () => {
      const hasOverflow = el.scrollWidth > el.clientWidth + 5;
      setCanScrollLeft(hasOverflow && el.scrollLeft > 5);
      setCanScrollRight(
        hasOverflow && el.scrollLeft + el.clientWidth < el.scrollWidth - 5,
      );
    };

    const syncButtons = () => {
      window.requestAnimationFrame(updateScrollButtons);
    };

    syncButtons();
    el.addEventListener("scroll", updateScrollButtons);
    window.addEventListener("resize", syncButtons);

    return () => {
      el.removeEventListener("scroll", updateScrollButtons);
      window.removeEventListener("resize", syncButtons);
    };
  }, [products.length]);

  const scrollCards = (direction) => {
    const el = scrollRef.current;
    if (!el) return;

    el.scrollBy({
      left: direction === "right" ? el.clientWidth : -el.clientWidth,
      behavior: "smooth",
    });
  };

  return (
    <section
      className="bigsavings"
      style={{ paddingInline: "5%" }}
      key={section.id ?? section.section_key ?? section.name}
    >
      <div className="bigsavings-header">
        {isTopSellerSection ? (
          <span
            style={{
              fontSize: "24px",
              fontWeight: "700",
              color: "black",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            {section.title || section.name || "Top Selling Products"}
            <span
              style={{
                fontSize: "14px",
                fontWeight: "500",
                color: "#666",
                background: "#f0f0f0",
                padding: "4px 12px",
                borderRadius: "20px",
              }}
            >
              Best Sellers
            </span>
          </span>
        ) : (
          <span style={{ fontSize: "18px", fontWeight: "500" }}>
            {section.name}
          </span>
        )}

        <div className="bigsavings-header-actions">
          {!isTopSellerSection ? (
            <a className="view-all" href={`/viewall/${section.id}`}>
              View All
            </a>
          ) : null}

          <div className="bigsavings-scroll-controls" aria-hidden={products.length <= 0}>
            <button
              type="button"
              className={`bigsavings-scroll-btn ${!canScrollLeft ? "is-disabled" : ""}`}
              onClick={() => scrollCards("left")}
              disabled={!canScrollLeft}
              aria-label={`Scroll ${section.name || section.title || "products"} left`}
            >
              <FaChevronLeft size={14} />
            </button>
            <button
              type="button"
              className={`bigsavings-scroll-btn ${!canScrollRight ? "is-disabled" : ""}`}
              onClick={() => scrollCards("right")}
              disabled={!canScrollRight}
              aria-label={`Scroll ${section.name || section.title || "products"} right`}
            >
              <FaChevronRight size={14} />
            </button>
          </div>
        </div>
      </div>

      <div style={{ marginBottom: "2%" }} className="bigsavings-wrapper">
        <div className="bigsavings-list" ref={scrollRef} role="list">
          {products.map((p) => {
            const originalPrice = cleanNumber(p.price);
            const discountedPrice = getDiscountedPrice(p.price, p.discount);

            return (
              <div className="bigsavings-item" key={p.id}>
                <ProductCard
                  id={p.id}
                  title={p.name}
                  imageUrl={p.image_url || (p.image_urls && p.image_urls[0])}
                  price={discountedPrice}
                  oldPrice={p.discount > 0 ? originalPrice : null}
                  discount={p.discount}
                  tagText={
                    p.description ? String(p.description).slice(0, 70) : null
                  }
                  description={p.description}
                  onAdd={() => onclickcart(makeCartData(p))}
                  category_id={p.category_id ?? section.id}
                  company_id={p.company_id}
                  featured={p.featured}
                  status={p.status}
                  stock_quantity={p.stock_quantity}
                  item={p}
                  catname={
                    isTopSellerSection
                      ? "Top Selling"
                      : section.name || section.title
                  }
                  onclickaddwishlist={() => onclickaddwishlist(makeCartData(p))}
                  is_wishlist={p.is_wishlisted}
                  removewishlistrequest={removewishlistrequest}
                  googleRating={
                    isTopSellerSection ? p.googleRating || 4.5 : undefined
                  }
                  googleReviews={
                    isTopSellerSection ? p.googleReviews || 128 : undefined
                  }
                />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

function Home({
  getcategoryRequest,
  categorydata,
  onclickcart,
  productdata,
  Homeproductdata,
  setAuthModalOpen,
  closeAuthModal,
  getproductbycategoryidRequest,
  addwishlistrequest,
  removewishlistrequest,
  branddata,
  categorywithsubcategorydata,
  getproductwithbrandRequest,
  topBanners,
  smallBanners,
  bottomBanners,
  loading,
}) {
  const [hoveredCategory, setHoveredCategory] = useState(null);
  const [activeSubcategoryId, setActiveSubcategoryId] = useState(null);
  const [expandedSubcategory, setExpandedSubcategory] = useState(null);
  const [flyoutOnLeft, setFlyoutOnLeft] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
  const [mobileDropdownTop, setMobileDropdownTop] = useState(0);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();
  const buttonRefs = useRef({});
  const dropdownRef = useRef(null);
  const categoriesRowRef = useRef(null);

  useEffect(() => {
    setIsMobile(getViewportIsMobile());

    const handleResize = () => {
      setIsMobile(getViewportIsMobile());
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const onclickaddwishlist = (data) => {
    addwishlistrequest(data.product_id);
  };

  const isDomNode = (node) => typeof Node !== "undefined" && node instanceof Node;

  const demoProducts = [
    {
      id: 1,
      title: "RMS X-Ray Machine",
      imageUrl: "https://www.orichmed.com/upload/product/1682384858974212.jpg",
      price: 161000,
      oldPrice: null,
      discount: null,
      tagText: "Get this for AED 1,49,730",
    },
    {
      id: 2,
      title: "RMS PC Based Spirometer",
      imageUrl:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSyz9k2ZOBqm3yi8KF0dxJ5k_3vQkOstkF96w&s",
      price: 33600,
      oldPrice: null,
      discount: null,
      tagText: "Get this for AED 31,248",
    },
    {
      id: 3,
      title: "RMS Vesta 12EC ECG Machine",
      imageUrl:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQqwVQ-jjWtP8bE67-flgvYVdphB8ps9v9GVw&s",
      price: 65000,
      oldPrice: 78000,
      discount: 17,
      tagText: "Get this for AED 60,450",
    },
    {
      id: 5,
      title: "RMS Mobile X-ray Machine with HRT",
      imageUrl:
        "https://d91ztqmtx7u1k.cloudfront.net/ClientContent/Images/Medium/carestream-machine-type-portable-mobile-digital-x-ray-20230818115052.jpg",
      price: 231000,
      oldPrice: null,
      discount: null,
      tagText: "Get this for AED 2,14,830",
    },
    {
      id: 6,
      title: "RMS TMT Machine",
      imageUrl: "https://perfectionnepal.com/img/tmt-rms-vega-201.jpg",
      price: 196000,
      oldPrice: null,
      discount: null,
      tagText: "Get this for AED 1,82,280",
    },
    {
      id: 7,
      title: "RMS EEG Machine",
      imageUrl:
        "https://asset.fujifilm.com/www/in/files/2019-11/5866e3ddeaab759b3eb6d35c52ea041b/thumb_su-1_01.jpg",
      price: 133000,
      oldPrice: null,
      discount: null,
      tagText: "Get this for AED 1,23,000",
    },
  ];

  // ===== NEW: DUMMY TOP SELLING PRODUCTS DATA (Separate from API) =====
  const topSellingDummyData = [
    {
      id: "top_001",
      name: "Advanced Digital X-Ray System",
      description:
        "High-resolution digital X-ray system with AI-powered imaging. Complete with wireless detector and advanced software.",
      price: 425000,
      oldPrice: 550000,
      discount: 23,
      image_url:
        "https://theicecommunity.com/wp-content/uploads/2025/07/definium-1024x640.jpg",
      image_urls: [
        "https://theicecommunity.com/wp-content/uploads/2025/07/definium-1024x640.jpg",
      ],
      category_id: "top_selling",
      company_id: "dummy_comp_001",
      featured: true,
      status: "active",
      stock_quantity: 45,
      is_wishlisted: false,
      rating: 4.8,
      sold_count: 1250,
    },
    {
      id: "top_002",
      name: "Portable Ultrasound Machine",
      description:
        "Wireless handheld ultrasound with color Doppler. Perfect for point-of-care diagnostics.",
      price: 185000,
      oldPrice: 245000,
      discount: 24,
      image_url:
        "https://cpimg.tistatic.com/09513768/b/4/GE-LOGIQ-e-BT12-Portable-Ultrasound-Machine.jpg",
      image_urls: [
        "https://cpimg.tistatic.com/09513768/b/4/GE-LOGIQ-e-BT12-Portable-Ultrasound-Machine.jpg",
      ],
      category_id: "top_selling",
      company_id: "dummy_comp_002",
      featured: true,
      status: "active",
      stock_quantity: 120,
      is_wishlisted: false,
      rating: 4.9,
      sold_count: 2100,
    },
    {
      id: "top_003",
      name: "Patient Monitoring System",
      description:
        "Multi-parameter patient monitor with touch screen. Tracks ECG, NIBP, SpO2, temperature, and respiration.",
      price: 125000,
      oldPrice: 165000,
      discount: 24,
      image_url:
        "https://vanninhealthcare.com/wp-content/uploads/2020/08/phoebe-pro-patient-monitor.png",
      image_urls: [
        "https://vanninhealthcare.com/wp-content/uploads/2020/08/phoebe-pro-patient-monitor.png",
      ],
      category_id: "top_selling",
      company_id: "dummy_comp_003",
      featured: true,
      status: "active",
      stock_quantity: 85,
      is_wishlisted: false,
      rating: 4.7,
      sold_count: 890,
    },
    {
      id: "top_004",
      name: "ICU Ventilator",
      description:
        "Advanced ICU ventilator with multiple ventilation modes. Ideal for critical care settings.",
      price: 295000,
      oldPrice: 380000,
      discount: 22,
      image_url:
        "https://www.superstar-med.net/image/cache/b/s1100-750x750.jpg",
      image_urls: [
        "https://www.superstar-med.net/image/cache/b/s1100-750x750.jpg",
      ],
      category_id: "top_selling",
      company_id: "dummy_comp_004",
      featured: true,
      status: "active",
      stock_quantity: 35,
      is_wishlisted: false,
      rating: 4.9,
      sold_count: 567,
    },
    {
      id: "top_005",
      name: "ECG Machine 12-Channel",
      description:
        "12-lead ECG machine with interpretation software. High-resolution thermal printer included.",
      price: 89000,
      oldPrice: 120000,
      discount: 26,
      image_url:
        "https://ik.imagekit.io/z6mqjyyzz/media/public/646c8f6eb981402bb_Contec_Twelve_Channel_ECG_Machine_-_1200G.1.jpeg?tr=w-1000,q-75,f-avif",
      image_urls: [
        "https://ik.imagekit.io/z6mqjyyzz/media/public/646c8f6eb981402bb_Contec_Twelve_Channel_ECG_Machine_-_1200G.1.jpeg?tr=w-1000,q-75,f-avif",
      ],
      category_id: "top_selling",
      company_id: "dummy_comp_005",
      featured: true,
      status: "active",
      stock_quantity: 150,
      is_wishlisted: false,
      rating: 4.6,
      sold_count: 734,
    },
    {
      id: "top_006",
      name: "Surgical LED Light",
      description:
        "Shadowless LED surgical light with adjustable intensity. Touch screen control panel.",
      price: 165000,
      oldPrice: 210000,
      discount: 21,
      image_url:
        "https://5.imimg.com/data5/SELLER/Default/2023/6/315665391/DD/TL/OB/692516/led-surgical-light.jpg",
      image_urls: [
        "https://5.imimg.com/data5/SELLER/Default/2023/6/315665391/DD/TL/OB/692516/led-surgical-light.jpg",
      ],
      category_id: "top_selling",
      company_id: "dummy_comp_006",
      featured: true,
      status: "active",
      stock_quantity: 28,
      is_wishlisted: false,
      rating: 4.8,
      sold_count: 445,
    },
    {
      id: "top_007",
      name: "Dental Chair Unit",
      description:
        "Modern dental chair with integrated delivery system. Ergonomic design with patient comfort features.",
      price: 215000,
      oldPrice: 280000,
      discount: 23,
      image_url:
        "https://www.dentmark.com/images/ProductImages/1902108252-1646832053.jpg",
      image_urls: [
        "https://www.dentmark.com/images/ProductImages/1902108252-1646832053.jpg",
      ],
      category_id: "top_selling",
      company_id: "dummy_comp_007",
      featured: true,
      status: "active",
      stock_quantity: 42,
      is_wishlisted: false,
      rating: 4.7,
      sold_count: 678,
    },
    {
      id: "top_008",
      name: "Centrifuge Machine",
      description:
        "High-speed refrigerated centrifuge with digital display. Suitable for clinical and research labs.",
      price: 75000,
      oldPrice: 99000,
      discount: 24,
      image_url:
        "https://www.sigmaaldrich.com/deepweb/assets/sigmaaldrich/product/images/333/078/a4f1819f-4580-434f-9f89-cb861bdf762e/640/a4f1819f-4580-434f-9f89-cb861bdf762e.jpg",
      image_urls: [
        "https://www.sigmaaldrich.com/deepweb/assets/sigmaaldrich/product/images/333/078/a4f1819f-4580-434f-9f89-cb861bdf762e/640/a4f1819f-4580-434f-9f89-cb861bdf762e.jpg",
      ],
      category_id: "top_selling",
      company_id: "dummy_comp_008",
      featured: true,
      status: "active",
      stock_quantity: 95,
      is_wishlisted: false,
      rating: 4.5,
      sold_count: 523,
    },
  ];

  const sampleTestimonials = [
    {
      id: 1,
      quote:
        "Interventional cardiology services at top-tier centres have transformed outcomes for our patients — the access to advanced devices makes a real difference.",
      name: "Dr. Ahmed Al-Mansouri",
      title: "Interventional Cardiologist, Cleveland Clinic Abu Dhabi",
      avatarUrl: "https://placehold.co/48x48?text=AA",
    },
    {
      id: 2,
      quote:
        "Advanced endoscopy and coordinated care models help reduce admission times and improve diagnostic yield for complex GI conditions.",
      name: "Dr. Fatima Al-Ketbi",
      title: "Gastroenterologist, Dubai Hospital",
      avatarUrl: "https://placehold.co/48x48?text=FA",
    },
    {
      id: 3,
      quote:
        "Minimally invasive joint replacement programmes reduce recovery time and get patients back to mobility faster — equipment quality is key.",
      name: "Dr. Omar Bin Salem",
      title: "Orthopaedic Surgeon (Joint Replacement), NMC Royal Hospital",
      avatarUrl: "https://placehold.co/48x48?text=OB",
    },
  ];

  const trustItems = [
    {
      icon: FiTruck,
      title: "Fast shipping",
      description:
        "Delivery expectations stay visible wherever data is available.",
    },
    {
      icon: FiRotateCcw,
      title: "Easy returns",
      description: "Policy and support links remain one click away for buyers.",
    },
    {
      icon: FiCreditCard,
      title: "Secure payments",
      description:
        "Checkout trust cues are surfaced without changing payment logic.",
    },
    {
      icon: FiHeadphones,
      title: "Customer support",
      description: "Reach support daily from 9:00 AM to 9:00 PM.",
    },
  ];

  const [current, setCurrent] = useState(0);
  const [currentSmall, setCurrentSmall] = useState(0);
  const bannerTouchStart = useRef(null);
  const bannerSwiped = useRef(false);
  const rowRef = useRef(null);

  const hasTopBanners = Array.isArray(topBanners) && topBanners.length > 0;
  const hasSmallBanners =
    Array.isArray(smallBanners) && smallBanners.length > 0;
  const shouldRenderTopBannerSection = hasTopBanners || hasSmallBanners;
  const hasBottomBanners =
    Array.isArray(bottomBanners) && bottomBanners.length > 0;
  const banners = hasTopBanners ? topBanners : [];
  const activeSmallBanners = Array.isArray(smallBanners) ? smallBanners : [];
  const hasSmallBannerCarousel = activeSmallBanners.length > 1;
  const getBannerImage = (banner) =>
    (Array.isArray(banner?.image_urls) ? banner.image_urls[0] : "") ||
    banner?.image_url ||
    "";
  const currentSmallBanner = activeSmallBanners[currentSmall] || null;
  const resolvedSmallBannerImage =
    getBannerImage(currentSmallBanner) || smallbanner;
  const resolvedSmallBannerLink = currentSmallBanner?.link_url || "";

  const prev = () =>
    setCurrent((c) =>
      hasTopBanners ? (c === 0 ? topBanners.length - 1 : c - 1) : 0,
    );
  const next = () =>
    setCurrent((c) =>
      hasTopBanners ? (c === topBanners.length - 1 ? 0 : c + 1) : 0,
    );
  const goTo = (i) => setCurrent(i);
  const handleBannerTouchStart = (event) => {
    if (!isMobile || banners.length < 2) return;
    const touch = event.touches[0];
    bannerTouchStart.current = { x: touch.clientX, y: touch.clientY };
  };
  const handleBannerTouchEnd = (event) => {
    const start = bannerTouchStart.current;
    bannerTouchStart.current = null;
    if (!start || !event.changedTouches.length) return;

    const touch = event.changedTouches[0];
    const deltaX = touch.clientX - start.x;
    const deltaY = touch.clientY - start.y;
    if (Math.abs(deltaX) < 45 || Math.abs(deltaX) <= Math.abs(deltaY)) return;

    if (deltaX > 0) prev();
    else next();
    bannerSwiped.current = true;
    window.setTimeout(() => { bannerSwiped.current = false; }, 400);
  };
  const listRef = useRef(null);
  const [cardWidth, setCardWidth] = useState(260);
  const [test, setTest] = useState([]);

  useEffect(() => {
    getcategoryRequest();
  }, []);

  useEffect(() => {
    if (!hasTopBanners) return;

    const interval = setInterval(() => {
      setCurrent((prevIndex) =>
        prevIndex === topBanners.length - 1 ? 0 : prevIndex + 1,
      );
    }, 4000);

    return () => clearInterval(interval);
  }, [hasTopBanners, topBanners.length]);

  useEffect(() => {
    if (hasTopBanners && current > topBanners.length - 1) {
      setCurrent(0);
    }
  }, [current, hasTopBanners, topBanners.length]);

  useEffect(() => {
    if (!hasSmallBannerCarousel) return;

    const interval = setInterval(() => {
      setCurrentSmall((prevIndex) =>
        prevIndex === activeSmallBanners.length - 1 ? 0 : prevIndex + 1,
      );
    }, 4000);

    return () => clearInterval(interval);
  }, [activeSmallBanners.length, hasSmallBannerCarousel]);

  useEffect(() => {
    if (currentSmall > activeSmallBanners.length - 1) {
      setCurrentSmall(0);
    }
  }, [activeSmallBanners.length, currentSmall]);

  useEffect(() => {
    const list = listRef.current;
    if (!list) return;

    const measure = () => {
      const first = list.querySelector(".pcard, .arrow-card");
      if (!first) return;
      const rect = first.getBoundingClientRect();
      const style = window.getComputedStyle(first);
      const ml = parseFloat(style.marginLeft) || 0;
      const mr = parseFloat(style.marginRight) || 0;
      setCardWidth(Math.round(rect.width + ml + mr));
    };

    measure();
    window.addEventListener("resize", measure);
    return () => window.removeEventListener("resize", measure);
  }, [demoProducts.length]);

  // Update scroll arrows visibility for categories row
  useEffect(() => {
    const updateScrollButtons = () => {
      if (!isMobile) {
        const row = categoriesRowRef.current;
        if (row) {
          setCanScrollLeft(row.scrollLeft > 10);
          setCanScrollRight(
            row.scrollLeft + row.clientWidth < row.scrollWidth - 10,
          );
        }
      }
    };

    const row = categoriesRowRef.current;
    if (row && !isMobile) {
      row.addEventListener("scroll", updateScrollButtons);
      window.addEventListener("resize", updateScrollButtons);
      updateScrollButtons();
    }

    return () => {
      if (row) {
        row.removeEventListener("scroll", updateScrollButtons);
      }
      window.removeEventListener("resize", updateScrollButtons);
    };
  }, [categorydata, isMobile]);

  const goToLogin = () => {
    navigate("/login");
  };

  const goToSignup = () => {
    navigate("/signup");
  };

  const scrollByCards = (n = 1) => {
    const list = listRef.current;
    if (!list) return;
    const delta = Math.round(cardWidth * n);
    list.scrollBy({ left: delta, behavior: "smooth" });
  };

  // Scroll categories row
  const scrollCategories = (direction) => {
    const row = categoriesRowRef.current;
    if (row) {
      const scrollAmount = 200;
      row.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  const onWheel = (e) => {
    const el = rowRef.current;
    if (!el) return;

    if (e.shiftKey) return;

    const canScrollHorizontally = el.scrollWidth > el.clientWidth;
    if (!canScrollHorizontally) return;

    e.preventDefault();
    el.scrollBy({
      left: e.deltaY,
      behavior: "smooth",
    });
  };

  const buildCategoryProductsSearch = ({
    type,
    categoryId,
    categoryName,
    subcategoryId,
    subcategoryName,
  }) => {
    const params = new URLSearchParams();
    params.set("type", type);

    if (categoryId) {
      params.set("categoryId", String(categoryId));
    }

    if (categoryName) {
      params.set("categoryName", categoryName);
    }

    if (type === "subcategory" && subcategoryId) {
      params.set("subcategoryId", String(subcategoryId));
    }

    if (type === "subcategory" && subcategoryName) {
      params.set("subcategoryName", subcategoryName);
    }

    return `?${params.toString()}`;
  };

  // Handle category click
  const handleCategoryClick = (id, idx) => {
    const selectedCategory =
      categorydata?.find((category) => category.id === id) ||
      categorywithsubcategorydata?.find((category) => category.id === id);

    if (isClinicalPlannersCategory(selectedCategory)) {
      setHoveredCategory(null);
      navigate(CLINICAL_PLANNERS_PATH);
      return;
    }

    const categoryName = selectedCategory?.name || "";
    const search = buildCategoryProductsSearch({
      type: "category",
      categoryId: id,
      categoryName,
    });

    setActiveIndex(idx);
    getproductbycategoryidRequest(id);
    navigate(
      {
        pathname: "/categoryproducts",
        search,
      },
      { state: { id, categoryName } },
    );
  };

  // Handle subcategory click
  const handleSubcategoryClick = (
    subCatId,
    subCatName,
    parentCatId,
    parentCatName,
  ) => {
    const categoryName =
      parentCatName ||
      categorydata?.find((category) => category.id === parentCatId)?.name ||
      "";
    const search = buildCategoryProductsSearch({
      type: "subcategory",
      categoryId: parentCatId,
      categoryName,
      subcategoryId: subCatId,
      subcategoryName: subCatName,
    });

    setHoveredCategory(null);
    setActiveIndex(null);
    navigate(
      {
        pathname: "/categoryproducts",
        search,
      },
      {
        state: {
          id: subCatId,
          type: "subcategory",
          catparentid: parentCatId,
          categoryName,
          subcategoryName: subCatName,
        },
      },
    );
  };

  const handleTagClick = (tag, parentCategory) => {
    if (tag.legacy_sub_category_id) {
      handleSubcategoryClick(
        tag.legacy_sub_category_id,
        tag.name,
        parentCategory.id,
        parentCategory.name,
      );
      return;
    }

    setHoveredCategory(null);
    navigate(`/search?q=${encodeURIComponent(tag.name)}`);
  };

  // Handle mouse enter for category with dropdown
  const handleMouseEnter = (catId, idx, e) => {
    if (isMobile) return;
    const button = buttonRefs.current[catId];
    const categoryData = categorywithsubcategorydata?.find(
      (cat) => cat.id === catId,
    );

    if (button && categoryData?.sub_categories?.length > 0) {
      const rect = button.getBoundingClientRect();
      const viewportWidth = window.innerWidth;
      const dropdownWidth = 280;

      let left = rect.left + window.scrollX;

      if (left + dropdownWidth > viewportWidth) {
        left = viewportWidth - dropdownWidth - 20;
      }

      if (left < 20) {
        left = 20;
      }

      setDropdownPosition({
        top: rect.bottom + window.scrollY + 5,
        left: left,
      });
      setFlyoutOnLeft(left + dropdownWidth + 260 > window.scrollX + viewportWidth - 20);
      setActiveSubcategoryId(null);
      setHoveredCategory(catId);
    }
  };

  // Handle mouse leave for the entire categories row
  const handleMouseLeave = (e) => {
    if (isMobile) return;

    const target = e.relatedTarget;
    if (!isDomNode(target) || !dropdownRef.current?.contains(target)) {
      setHoveredCategory(null);
    }
  };

  // Handle mouse leave for dropdown - FIXED VERSION
  const handleDropdownMouseLeave = (e) => {
    if (isMobile) return;

    if (!hoveredCategory) return;
    const button = buttonRefs.current[hoveredCategory];
    const target = e.relatedTarget;
    if (!isDomNode(target) || (button && !button.contains(target))) {
      setHoveredCategory(null);
    }
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        const isButton = Object.values(buttonRefs.current).some(
          (ref) => ref && ref.contains(event.target),
        );
        if (!isButton) {
          setHoveredCategory(null);
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (!isMobile || !hoveredCategory) return undefined;

    const updatePosition = () => {
      const button = buttonRefs.current[hoveredCategory];
      if (!button) return;

      const headerBottom = document.querySelector(".site-header")?.getBoundingClientRect().bottom || 0;
      const buttonRect = button.getBoundingClientRect();
      if (buttonRect.bottom <= headerBottom) {
        setHoveredCategory(null);
        return;
      }
      setMobileDropdownTop(buttonRect.bottom + 6);
    };

    window.addEventListener("scroll", updatePosition, { passive: true });
    window.addEventListener("resize", updatePosition);
    return () => {
      window.removeEventListener("scroll", updatePosition);
      window.removeEventListener("resize", updatePosition);
    };
  }, [isMobile, hoveredCategory]);

  function makeCartData(product) {
    const qty = 1;
    const priceNumber = Number(product?.price ?? product?.price_number ?? 0);
    const discountNumber = Number(product?.discount ?? 0);

    return {
      id: product.id,
      product_id: product.id,
      title: product.name ?? product.title,
      price: priceNumber,
      oldPrice: product.oldPrice ?? product.old_price ?? null,
      discount: discountNumber,
      quantity: qty,
      imageUrl:
        product.image_url || (product.image_urls && product.image_urls[0]),
      image_urls:
        product.image_urls || (product.image_urls && product.image_urls),
      stock_quantity: product.stock_quantity ?? null,
      category_id: product.category_id ?? null,
      company_id: product.company_id ?? null,
      attributes: product.attributes || {},
      original: product,
    };
  }

  // Function to get category data with subcategories
  const getCategoryWithSubcategories = (catId) => {
    return categorywithsubcategorydata?.find((cat) => cat.id === catId);
  };

  const cleanNumber = (value) => {
    if (!value) return 0;
    return Number(value.toString().replace(/,/g, ""));
  };

  const getDiscountedPrice = (price, discount) => {
    const p = cleanNumber(price);
    const d = cleanNumber(discount);
    return d > 0 ? p * (1 - d / 100) : p;
  };

  const handleCategoryClickMobile = (catId, idx, e) => {
    if (isMobile) {
      const categoryData = categorywithsubcategorydata?.find(
        (cat) => cat.id === catId,
      );

      if (categoryData?.sub_categories?.length > 0) {
        e.preventDefault();
        e.stopPropagation();
        setActiveSubcategoryId(null);
        setExpandedSubcategory(null);
        if (hoveredCategory === catId) {
          setHoveredCategory(null);
          return;
        }

        const button = buttonRefs.current[catId];
        if (button) {
          button.scrollIntoView({ block: "nearest", inline: "center", behavior: "instant" });
          const headerBottom = document.querySelector(".site-header")?.getBoundingClientRect().bottom || 0;
          const rect = button.getBoundingClientRect();
          const availableBelow = window.innerHeight - rect.bottom;
          if (availableBelow < Math.min(320, window.innerHeight * 0.45)) {
            window.scrollTo({
              top: window.scrollY + Math.max(0, rect.top - headerBottom - 8),
              behavior: "instant",
            });
          }
          setMobileDropdownTop(button.getBoundingClientRect().bottom + 6);
        }
        setHoveredCategory(catId);
      } else {
        // If no subcategories, navigate directly
        handleCategoryClick(catId, idx);
      }
    }
  };

  const orderedHomeSections =
    Array.isArray(Homeproductdata) && Homeproductdata.length > 0
      ? Homeproductdata.filter(
          (section) =>
            Array.isArray(section.products) && section.products.length > 0,
        )
      : [];

  const renderProductSection = (section) => {
    return (
      <CategoryProductCarousel
        key={section.id ?? section.section_key ?? section.name}
        section={section}
        onclickcart={onclickcart}
        onclickaddwishlist={onclickaddwishlist}
        removewishlistrequest={removewishlistrequest}
        makeCartData={makeCartData}
        cleanNumber={cleanNumber}
        getDiscountedPrice={getDiscountedPrice}
      />
    );
  };

  return (
    <>
      {/* Categories Row with Dropdown and Scroll Arrows */}
      <div className="banner-categories-container-wrapper">
        <div className="banner-categories-container">
          {!isMobile && canScrollLeft && (
            <button
              className="categories-scroll-btn left"
              onClick={() => scrollCategories("left")}
              aria-label="Scroll categories left"
            >
              <FaChevronLeft size={14} />
            </button>
          )}

          <div
            className={`banner-categories-row ${
              categorydata?.length <= 5 && !isMobile ? "center-align" : ""
            }`}
            ref={categoriesRowRef}
            onMouseLeave={handleMouseLeave}
          >
            {categorydata &&
              categorydata.map((cat, idx) => {
                const categoryWithSub = getCategoryWithSubcategories(cat.id);
                const hasSubcategories =
                  categoryWithSub?.sub_categories?.length > 0;

                return (
                  <div
                    key={cat.id}
                    style={{ position: "relative", display: "inline-block" }}
                  >
                    <button
                      ref={(el) => (buttonRefs.current[cat.id] = el)}
                      className={`banner-category-pill ${
                        activeIndex === idx ? "active" : ""
                      } ${isMobile && hoveredCategory === cat.id ? "is-open" : ""} ${hasSubcategories ? "has-subcategories" : ""}`}
                      onClick={(e) => {
                        if (isMobile && hasSubcategories) {
                          handleCategoryClickMobile(cat.id, idx, e);
                        } else {
                          handleCategoryClick(cat.id, idx);
                        }
                      }}
                      onMouseEnter={(e) => handleMouseEnter(cat.id, idx, e)}
                      aria-pressed={activeIndex === idx}
                      aria-expanded={isMobile && hasSubcategories ? hoveredCategory === cat.id : undefined}
                      aria-controls={isMobile && hasSubcategories ? "mobile-category-subcategories" : undefined}
                      aria-label={`View ${cat.name} category${
                        hasSubcategories ? " with dropdown" : ""
                      }`}
                      type="button"
                    >
                      <div
                        style={{
                          display: "flex",
                          gap: "8px",
                          alignItems: "center",
                        }}
                      >
                        <div className="banner-category-name">{cat.name}</div>
                        {hasSubcategories && (
                          <FaChevronDown
                            size={12}
                            style={{
                              opacity: 0.7,
                              transition:
                                "transform 0.2s ease, opacity 0.2s ease",
                              transform:
                                hoveredCategory === cat.id
                                  ? "rotate(180deg)"
                                  : "rotate(0deg)",
                            }}
                          />
                        )}
                      </div>
                    </button>
                  </div>
                );
              })}
          </div>

          {!isMobile && canScrollRight && (
            <button
              className="categories-scroll-btn right"
              onClick={() => scrollCategories("right")}
              aria-label="Scroll categories right"
            >
              <FaChevronRight size={14} />
            </button>
          )}
        </div>

        {/* Category dropdown */}
        {hoveredCategory &&
          (() => {
            const categoryData = getCategoryWithSubcategories(hoveredCategory);
            if (categoryData?.sub_categories?.length > 0) {
              const activeSubcategory = categoryData.sub_categories.find(
                (subCat) => subCat.id === activeSubcategoryId && subCat.tags?.length > 0,
              );
              return (
                <>
                  <div
                    id={isMobile ? "mobile-category-subcategories" : undefined}
                    ref={dropdownRef}
                    className={`category-dropdown ${flyoutOnLeft ? "flyout-left" : ""}`}
                    style={
                      !isMobile
                        ? {
                            position: "absolute",
                            top: `${dropdownPosition.top}px`,
                            left: `${dropdownPosition.left}px`,
                            zIndex: 1000,
                          }
                        : {
                            top: `${mobileDropdownTop}px`,
                            "--category-dropdown-top": `${mobileDropdownTop}px`,
                          }
                    }
                    onMouseLeave={handleDropdownMouseLeave}
                  >
                    <div className="dropdown-content">
                      <div className="subcategories-list">
                        {categoryData.sub_categories.map((subCat) => (
                          <div
                            key={subCat.id}
                            className={`subcategory-group ${expandedSubcategory === subCat.id ? "is-expanded" : ""}`}
                            onMouseEnter={() => { if (!isMobile) setActiveSubcategoryId(subCat.tags?.length ? subCat.id : null); }}
                            onFocus={() => { if (!isMobile) setActiveSubcategoryId(subCat.tags?.length ? subCat.id : null); }}
                          >
                            <div className="subcategory-row">
                              <button
                                className="subcategory-item"
                                onClick={() =>
                                  handleSubcategoryClick(
                                    subCat.id,
                                    subCat.name,
                                    categoryData.id,
                                    categoryData.name,
                                  )
                                }
                                aria-label={`View ${subCat.name} subcategory`}
                                type="button"
                              >
                                <div className="subcategory-info">
                                  {subCat.image_url && (
                                    <img
                                      src={subCat.image_url}
                                      alt={subCat.name}
                                      className="subcategory-image"
                                      onError={(e) => {
                                        e.target.style.display = "none";
                                      }}
                                    />
                                  )}
                                  <span className="subcategory-name">
                                    {subCat.name}
                                  </span>
                                </div>
                                {!isMobile && subCat.tags?.length > 0 && (
                                  <FaChevronRight className="subcategory-chevron" size={12} />
                                )}
                              </button>
                              {isMobile && subCat.tags?.length > 0 && (
                                <button
                                  className="subcategory-expand"
                                  type="button"
                                  aria-label={`${expandedSubcategory === subCat.id ? "Collapse" : "Expand"} ${subCat.name} tags`}
                                  aria-expanded={expandedSubcategory === subCat.id}
                                  onClick={() => setExpandedSubcategory(expandedSubcategory === subCat.id ? null : subCat.id)}
                                >
                                  <FaChevronDown size={14} />
                                </button>
                              )}
                            </div>
                            {isMobile && subCat.tags?.length > 0 && (
                              <div className="subcategory-tags">
                                {subCat.tags.map((tag) => (
                                  <button
                                    key={tag.id}
                                    className="subcategory-item subcategory-tag-item"
                                    onClick={() => handleTagClick(tag, categoryData)}
                                    aria-label={`View ${tag.name} products in ${subCat.name}`}
                                    type="button"
                                  >
                                    <span className="subcategory-name">{tag.name}</span>
                                  </button>
                                ))}
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                      {!isMobile && activeSubcategory && (
                        <div className="subcategory-tags-panel" aria-label={`${activeSubcategory.name} products`}>
                          <div className="subcategory-panel-heading">{activeSubcategory.name}</div>
                          {activeSubcategory.tags.map((tag) => (
                            <button
                              key={tag.id}
                              className="subcategory-item subcategory-tag-item"
                              onClick={() => handleTagClick(tag, categoryData)}
                              aria-label={`View ${tag.name} products in ${activeSubcategory.name}`}
                              type="button"
                            >
                              <span className="subcategory-name">{tag.name}</span>
                            </button>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </>
              );
            }
            return null;
          })()}
      </div>

      {shouldRenderTopBannerSection ? (
        <div style={{ marginTop: "3%", width: "100%" }}>
          <div
            className="home-banner-container"
            aria-roledescription="carousel"
          >
            <div className="banner-flex-container">
              {hasTopBanners ? (
                <div
                  className="banner-slide main-banner"
                  role="group"
                  aria-roledescription="slide"
                  aria-label={`Banner ${current + 1} of ${banners.length}`}
                  onTouchStart={handleBannerTouchStart}
                  onTouchEnd={handleBannerTouchEnd}
                  onTouchCancel={() => { bannerTouchStart.current = null; }}
                  onClickCapture={(event) => {
                    if (!bannerSwiped.current) return;
                    event.preventDefault();
                    event.stopPropagation();
                    bannerSwiped.current = false;
                  }}
                >
                  <a
                    href={banners[current]?.link_url || "#"}
                    className="banner-link"
                  >
                    <img
                      src={getBannerImage(banners[current])}
                      alt={banners[current]?.title || `Banner ${current + 1}`}
                      className="banner-image-main"
                      draggable="false"
                    />
                  </a>
                </div>
              ) : (
                <div
                  className="banner-slide main-banner"
                  aria-hidden="true"
                  style={{ visibility: "hidden" }}
                >
                  <img
                    src={smallbanner}
                    alt=""
                    className="banner-image-main"
                    draggable="false"
                  />
                </div>
              )}
              <div className="banner-slide small-banner">
                {resolvedSmallBannerLink ? (
                  <a href={resolvedSmallBannerLink} className="banner-link">
                    <img
                      src={resolvedSmallBannerImage}
                      alt={currentSmallBanner?.title || "banner"}
                      className="banner-image-small"
                    />
                  </a>
                ) : (
                  <img
                    src={resolvedSmallBannerImage}
                    alt={currentSmallBanner?.title || "banner"}
                    className="banner-image-small"
                  />
                )}
              </div>
            </div>

            {hasTopBanners ? (
              <div
                className="banner-dots"
                onKeyDown={(event) => {
                  if (!isMobile || banners.length < 2) return;
                  if (event.key === "ArrowLeft") {
                    event.preventDefault();
                    prev();
                  } else if (event.key === "ArrowRight") {
                    event.preventDefault();
                    next();
                  }
                }}
              >
                {banners.map((banner, i) => (
                  <button
                    type="button"
                    key={banner?.id || i}
                    className={`dot ${i === current ? "active" : ""}`}
                    onClick={() => goTo(i)}
                    aria-label={`Go to banner ${i + 1}`}
                    aria-current={i === current ? "true" : undefined}
                  />
                ))}
              </div>
            ) : null}
          </div>
        </div>
      ) : null}

      <section
        className="brands-section"
        aria-label="Search Products by Top Brands"
        style={{ paddingInline: "5%", marginTop: "3%" }}
      >
        <div
          style={{ display: "flex", justifyContent: "space-between" }}
          className="brands-header"
        >
          <h2 className="brands-title">Search Products by Top Brands</h2>
          <a className="brands-viewall" href="/brands">
            View All
          </a>
        </div>

        <div style={{ marginTop: "20px" }}>
          <Swiper
            modules={[Pagination, Autoplay]}
            spaceBetween={1}
            slidesPerView={6}
            pagination={{ clickable: true }}
            autoplay={{ delay: 2500, disableOnInteraction: false }}
            breakpoints={{
              320: { slidesPerView: 2 },
              480: { slidesPerView: 3 },
              768: { slidesPerView: 4 },
              1024: { slidesPerView: 5 },
              1280: { slidesPerView: 6 },
            }}
          >
            {branddata &&
              branddata.map((b) => (
                <SwiperSlide key={b.id}>
                  <button
                    className="brand-card"
                    onClick={() => navigate(`/brandsproduct/${b.id}`)}
                  >
                    <div>
                      {b.image_url && (
                        <img
                          src={b.image_url}
                          alt={b.name}
                          className="brand-image"
                        />
                      )}
                    </div>
                    <div className="brand-name">{b.name}</div>
                  </button>
                </SwiperSlide>
              ))}
          </Swiper>
        </div>
      </section>

      <section className="home-section">
        <div className="home-trust-strip">
          {trustItems.map((item) => {
            const Icon = item.icon;
            return (
              <div className="home-trust-item" key={item.title}>
                <span className="home-trust-item__icon">
                  <Icon />
                </span>
                <div>
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      {orderedHomeSections.map(renderProductSection)}

      {hasBottomBanners ? (
        <div style={{ marginTop: "3%", paddingInline: "5%" }}>
          {bottomBanners.map((banner) => (
            <div
              key={banner.id}
              className="banner-slide"
              style={{ marginBottom: 16 }}
            >
              <a href={banner.link_url || "#"}>
                <img
                  src={getBannerImage(banner)}
                  alt={banner.title || "Banner"}
                  className="banner-image"
                  draggable="false"
                />
              </a>
            </div>
          ))}
        </div>
      ) : null}

      <div style={{ paddingInline: "8%" }}>
        <TestimonialsSection
          title="What Our Customers Say About Us"
          items={sampleTestimonials}
        />
      </div>
      <div style={{ paddingInline: "8%" }}>
        <BlogSection />
      </div>
      <Modal
        isOpen={setAuthModalOpen}
        onClose={closeAuthModal}
        maxWidth="500px"
      >
        <div
          style={{ padding: "12px 8px", textAlign: "center", fontWeight: 600 }}
        >
          <p style={{ marginTop: 0 }}>
            You need to be logged in to perform this action.
          </p>
          <div
            style={{
              display: "flex",
              gap: 10,
              marginTop: 14,
              justifyContent: "center",
            }}
          >
            <button
              onClick={goToLogin}
              style={{
                background: "#0f2747",
                color: "#fff",
                border: "none",
                padding: "10px 14px",
                borderRadius: 8,
                cursor: "pointer",
                fontWeight: 700,
              }}
            >
              Login
            </button>

            <button
              onClick={goToSignup}
              style={{
                background: "transparent",
                border: "1px solid #cbd5e1",
                padding: "10px 14px",
                borderRadius: 8,
                cursor: "pointer",
                fontWeight: 600,
              }}
            >
              Signup
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default Home;
